"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinkButton = _interopRequireDefault(require("../../Buttons/LinkButton"));

var _MenuItem = require("./MenuItem.styles");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The MenuItem component is intended to be wrapped in a MenuItemsWrapper component for use in a Menu
 */
var MenuItem = function MenuItem(_ref) {
  var childkey = _ref.childkey,
      children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      menuAction = _ref.menuAction,
      props = _objectWithoutProperties(_ref, ["childkey", "children", "className", "dataTestId", "menuAction"]);

  return /*#__PURE__*/_react.default.createElement(_MenuItem.StyledMenuItem, _extends({
    childkey: childkey,
    className: className,
    "data-test-id": dataTestId
  }, props), /*#__PURE__*/_react.default.createElement(_LinkButton.default, {
    className: "c-menu-item-link-button",
    dataTestId: "menu-item-link-button",
    onClick: menuAction
  }, children));
};

MenuItem.propTypes = {
  /** The childKey is necessary to tell the menu if this is an item to display when logged in or logged out */
  childkey: _propTypes.default.oneOf(['loggedInItems', 'loggedOutItems', 'all']).isRequired,

  /** Any nodes that are valid children of an HTML button */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Action to execute when the menu item is selected */
  menuAction: _propTypes.default.func
};
MenuItem.defaultProps = {
  children: undefined,
  className: '',
  menuAction: function menuAction() {}
};
var _default = MenuItem;
exports.default = _default;